/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdminClassifierService {

  constructor(private http: HttpClient) { }

    getClassifiers(): Observable<any> {
      return this.http
        .get(
          `/api/v1/admin/classifier`
        );
    }

    getClassifierAccounts(): Observable<any> {
      return this.http
        .get(
          `/api/v1/admin/classifier/account`
        );
    }

    newClassifier(name: string, accountId: string = null): Observable<any> {
      let classifier: any = {
        account_id: accountId,
        name: name,
        config: {},
        training: {
          nb: {
            training: [],
            stopword: []
          },
          phrase: {
            training: []
          },
          subject: {}
        },
        enabled: true
      };

      return this.http
      .post(
        `/api/v1/admin/classifier`,
        classifier
      );
    }

    addNBTraining(classifierId: string, model: any) {
      return this.http
      .post(
        `/api/v1/admin/classifier/${classifierId}/nbtraining`,
        model
      );
    }

    updateNBTraining(classifierId: string, trainingId: string, model: any) {
      return this.http
      .post(
        `/api/v1/admin/classifier/${classifierId}/nbtraining/${trainingId}`,
        model
      );
    }

    deleteNBTraining(classifierId: string, trainingId: string) {
      return this.http
      .delete(
        `/api/v1/admin/classifier/${classifierId}/nbtraining/${trainingId}`
      );
    }

    addNBStopword(classifierId: string, model: any) {
      return this.http
      .post(
        `/api/v1/admin/classifier/${classifierId}/nbstopword`,
        model
      );
    }

    deleteNBStopword(classifierId: string, stopwordId: string) {
      return this.http
      .delete(
        `/api/v1/admin/classifier/${classifierId}/nbstopword/${stopwordId}`
      );
    }

    updateNBCategoryConfig(classifierId: string, model: any) {
      return this.http
      .post(
        `/api/v1/admin/classifier/${classifierId}/nbcategory`,
        model
      );
    }

    addPhraseTraining(classifierId: string, model: any) {
      return this.http
      .post(
        `/api/v1/admin/classifier/${classifierId}/phrasetraining`,
        model
      );
    }

    updatePhraseTraining(classifierId: string, trainingId: string, model: any) {
      return this.http
      .post(
        `/api/v1/admin/classifier/${classifierId}/phrasetraining/${trainingId}`,
        model
      );
    }

    deletePhraseTraining(classifierId: string, trainingId: string) {
      return this.http
      .delete(
        `/api/v1/admin/classifier/${classifierId}/phrasetraining/${trainingId}`
      );
    }

    getAllCustomClassifierResults(customerEmailId: string) {
      return this.http
      .get(
        `/api/v1/admin/classifier/custom/${customerEmailId}`
      );
    }

    getWordmap(classifierId: string, category: string, language: string) {
      return this.http
      .get(
        `/api/v1/admin/classifier/${classifierId}/wordmap/${category}/${language}`
      );
    }
}



// WEBPACK FOOTER //
// ./client/app/services/admin/admin-classifier.service.ts